/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

/**
 * Returns the imgix url for the given filename.
 */
export function getImageUrl(filename: string): string {
  const imgUrlBase = `https://vienna-${process.env.ENVIRONMENT}.imgix.net/`;
  const imgExtension = filename?.split(".").pop();
  const imgId = filename?.split(".").shift();
  const encodedImgName = encodeURIComponent(`${imgId}.${imgExtension || ""}`);
  return `${imgUrlBase}${encodedImgName}`;
}

export const createImage = (src: string, dimensions?: { width: number; height: number }): HTMLImageElement => {
  const img = new Image(dimensions?.width, dimensions?.height);
  img.src = src;
  return img;
};

export const getCDNDomain = (): string => {
  switch (process.env.ENVIRONMENT) {
    case "dev":
      return "https://d2k7r8p462gl1x.cloudfront.net";
    case "local":
      return "https://d1fhgen2k8n7xm.cloudfront.net";
    default:
      return "https://d1qx4aitdy9duy.cloudfront.net";
  }
};
